module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"brandonvervoort","short_name":"Brandons Portfolio","start_url":"/","background_color":"#f7f7f7)","theme_color":"#009fb8","display":"minimal-ui","icon":"src/images/Logos/bv-logo-light.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"cbf73331aa60c105021e12dd35016b47"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
